import * as echarts from 'echarts';

const appointmentsByMonthContainer = document.getElementById('appointments-by-month-chart');
const appointmentsBySpecialtyContainer = document.getElementById('appointments-by-specialty-chart');

if (appointmentsByMonthContainer) {
    const dataset = JSON.parse(appointmentsByMonthContainer.getAttribute('data-dataset'));
    const appointmentsByMonthChart = new echarts.init(appointmentsByMonthContainer);
    window.addEventListener('resize', () => {
        appointmentsByMonthChart.resize();
    });
    appointmentsByMonthChart.setOption({
        grid: {
            left: 0,
            containLabel: true,
            bottom: 0,
            top: 30,
            right: 0,
        },
        xAxis: {
            data: dataset.labels,
        },
        yAxis: {},
        series: [
            {
                name: 'appointments',
                type: 'bar',
                data: dataset.values,
            },
        ],
    });
}

if (appointmentsBySpecialtyContainer) {
    const dataset = JSON.parse(appointmentsBySpecialtyContainer.getAttribute('data-dataset'));
    const appointmentsBySpecialtyChart = new echarts.init(appointmentsBySpecialtyContainer);
    window.addEventListener('resize', () => {
        appointmentsBySpecialtyChart.resize();
    });
    appointmentsBySpecialtyChart.setOption({
        grid: {
            left: 0,
            containLabel: true,
            bottom: 0,
            top: 30,
            right: 0,
        },
        legend: {
            top: 'bottom',
            orient: 'horizontal',
        },
        tooltip: {
            trigger: 'item',
            formatter: '{b} - {c} - {d}%',
        },
        series: [
            {
                name: 'appointments',
                type: 'pie',
                data: dataset,
                center: ['50%', '40%'],
                label: {
                    show: false,
                },
                labelLine: {
                    show: false,
                },
            },
        ],
    });
}
